"use client"

import { useLocale, useTranslations } from "next-intl"

import { accent } from "@/features/referrals/ReferralDialog"
import type { Locale } from "@/i18n/locales"
import { formatMoneyWhole, moneyFromCents } from "@/lib/money"
import type { ReferralTerms } from "@/platform/api/referrals"

export const useReferralTermsCopy = (terms: ReferralTerms) => {
  const t = useTranslations("referrals")
  const locale = useLocale() as Locale
  const money = (cents: number) => formatMoneyWhole(moneyFromCents(cents, terms.currency), locale)
  const earns = terms.referrer_reward_cents > 0
  const discount = money(terms.friend_discount_cents)
  const reward = money(terms.referrer_reward_cents)
  const maxEarning = money(terms.max_earning_cents)
  return {
    earns,
    discount,
    reward,
    maxEarning,
    titleLead: earns ? t("dialog.titleLead") : t("dialog.titleLeadFriendOnly"),
    titleEmphasis: earns ? t("dialog.titleEmphasis", { amount: maxEarning }) : t("dialog.titleEmphasisFriendOnly", { discount }),
    instagramBody: earns ? t("dialog.instagramBody", { reward, amount: maxEarning }) : t("dialog.instagramBodyFriendOnly", { discount }),
    benefits: [
      ...(earns ? [{ icon: "/images/referrals/gift.svg", text: t.rich("dialog.benefitReward", { reward, accent }) }] : []),
      { icon: "/images/referrals/ticket-group.svg", text: t.rich("dialog.benefitFriend", { discount, accent }) },
      ...(earns
        ? [{ icon: "/images/referrals/list-numbers.svg", text: t.rich("dialog.benefitLimit", { count: terms.max_rewards_per_referrer, amount: maxEarning, accent }) }]
        : []),
    ],
  }
}
